module.exports = __webpack_public_path__ + "static/img/bj_activate.3369cd9.png";